import { z } from 'zod'

/** AXF-1281: GET /api/usm/v1/admin/tenants/not-on-identity. */
export const notOnIdentityWorkspaceSchema = z.object({
  tenantId: z.string(),
  name: z.string(),
  slug: z.string(),
  status: z.string(),
  createdAt: z.string(),
  activePeople: z.number(),
  adminEmails: z.array(z.string()),
})

export const notOnIdentityPersonSchema = z.object({
  tenantId: z.string(),
  workspaceName: z.string(),
  licenceContractId: z.string().nullable(),
  userId: z.string(),
  displayName: z.string(),
  email: z.string(),
  role: z.enum(['Admin', 'Member']),
  isStaff: z.boolean(),
  reason: z.enum(['no_licence', 'no_identity_account']),
  lastLoginAt: z.string().nullable(),
})

export const notOnIdentityReportSchema = z.object({
  generatedAt: z.string(),
  workspaces: z.array(notOnIdentityWorkspaceSchema),
  people: z.array(notOnIdentityPersonSchema),
})

export const notOnIdentityResponseSchema = z.object({
  success: z.boolean(),
  data: notOnIdentityReportSchema,
})

export type NotOnIdentityWorkspace = z.infer<typeof notOnIdentityWorkspaceSchema>
export type NotOnIdentityPerson = z.infer<typeof notOnIdentityPersonSchema>
export type NotOnIdentityReport = z.infer<typeof notOnIdentityReportSchema>
export type NotOnIdentityReason = NotOnIdentityPerson['reason']
